import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Button } from "reactstrap";
import { Checkbox } from "antd";
import Axios from "axios";

import ViewInvitation from "../Modals/ViewInvitation/ViewInvitation";
import { sendInvitation } from "../../pages/Invitation/Invitation";
import { AssociationUrl } from "../../config/properties";
import { putAssociations } from "../Billsby/graphql";

const Associations = ({ organizationId }) => {
  const [organization, setOrganization] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [fiaAffiliation, setFiaAffiliation] = useState(false);
  const [nffsAffiliation, setNffsAffiliation] = useState(false);

  const getOrganization = async (orgId) => {
    const response = await Axios.get(`${AssociationUrl}/updateRemote?orgId=${orgId}&doNotUpdateRemote=true&doNotCreateOrgs=true`);
    setOrganization(response.data);
    const industryAssociations = response.data.industryAssociations;
    const hasFia = industryAssociations && industryAssociations.includes('FIA');
    setFiaAffiliation(hasFia);
    const hasNffs = industryAssociations && industryAssociations.includes('NFFS');
    setNffsAffiliation(hasNffs);
  }

  const connectedFia = () => {
    const assoc = organization.associationValidations;
    if (assoc) {
      const fiaAssoc = assoc.find(a => a.name === 'FIA');
      if (fiaAssoc) {
        if (fiaAssoc.status !== 'unknown') {
          return true;
        }
      }
    }
    return false;
  }

  const fiaTitle = () =>
    connectedFia() ?
      'Already connected to FIA remote' :
      'Check to connect to FIA remote when Sync is performed';


  const connectedNffs = () => {
    const assoc = organization.associationValidations;
    if (assoc) {
      const nffsAssoc = assoc.find(a => a.name === 'NFFS');
      if (nffsAssoc) {
        if (nffsAssoc.status !== 'unknown') {
          return true;
        }
      }
    }
    return false;
  }

  const nffsTitle = () =>
    connectedNffs() ?
      'Already connected to NFFS remote' :
      'Check to connect to NFFS remote when Sync is performed';

  const toggleFiaAffiliation = async () => {
    let industryAssociations = organization.industryAssociations;
    if (!industryAssociations) {
      industryAssociations = [];
    }
    let associationValidations = organization.associationValidations;
    if (!associationValidations) {
      associationValidations = [];
    }
    let i = industryAssociations.findIndex(a => a === 'FIA');
    if (i >= 0) {
      industryAssociations.splice(i, 1);
    } else {
      industryAssociations.unshift('FIA');
    }
    i = associationValidations.findIndex(a => a.name === 'FIA');
    if (i >= 0) {
      associationValidations.splice(i, 1);
      setFiaAffiliation(false);
    } else {
      associationValidations.unshift({ name: 'FIA', status: 'unknown' })
      setFiaAffiliation(true);
    }
    await putAssociations(organization.id, industryAssociations, associationValidations);
    setOrganization({ ...organization, industryAssociations, associationValidations })
  }

  const toggleNffsAffiliation = async () => {
    let industryAssociations = organization.industryAssociations;
    if (!industryAssociations) {
      industryAssociations = [];
    }
    let associationValidations = organization.associationValidations;
    if (!associationValidations) {
      associationValidations = [];
    }
    let i = industryAssociations.findIndex(a => a === 'NFFS');
    if (i >= 0) {
      industryAssociations.splice(i, 1);
    } else {
      industryAssociations.unshift('NFFS');
    }
    i = associationValidations.findIndex(a => a.name === 'NFFS');
    if (i >= 0) {
      associationValidations.splice(i, 1);
      setFiaAffiliation(false);
    } else {
      associationValidations.unshift({ name: 'NFFS', status: 'unknown' })
      setFiaAffiliation(true);
    }
    await putAssociations(organization.id, industryAssociations, associationValidations);
    setOrganization({ ...organization, industryAssociations, associationValidations })
  }

  useEffect(() => {
    getOrganization(organizationId);
  }, []);

  const openViewModal = () => {
    setShowViewModal(true);
  }

  const closeViewModal = () => {
    setShowViewModal(false);
  }

  const onSync = async () => {
    const data = await sendInvitation(organization);
    onUpdate(data);
  }

  const onUpdate = async (data) => {
    setOrganization(data);
  }

  if (!organization) {
    return (<p>Loading...</p>);
  }
  return (
    <div>
      <p>Allow synchronization with NFFS and/or FIA</p>
      <Checkbox
        title={fiaTitle()}
        checked={fiaAffiliation}
        onClick={toggleFiaAffiliation}
        disabled={connectedFia()}
      />
      &nbsp;<b title={fiaTitle()}>FIA</b>&nbsp;
      <Checkbox
        title={nffsTitle()}
        checked={nffsAffiliation}
        onClick={toggleNffsAffiliation}
        disabled={connectedNffs()}
      />
      &nbsp;<b title={nffsTitle()}>NFFS</b>&nbsp;&nbsp;
      <Button
        onClick={openViewModal}
      >
        View
      </Button>
      &nbsp;&nbsp;
      <Button
        onClick={onSync}
      >
        {organization.iconStatus === 'approved' || organization.iconStatus === 'Approved' ? 'Sync' : (organization.iconStatus || organization.inviteDate ? 'Update' : 'Invite')}
      </Button>
      <ViewInvitation
        item={organization}
        showViewModal={showViewModal}
        closeViewModal={closeViewModal}
        onUpdate={onUpdate}
      />
    </div>
  )
}

Associations.propTypes = {
  organizationId: PropTypes.string.isRequired,
}

export default Associations;



// WEBPACK FOOTER //
// ./src/components/Associations/Association.jsx